import { render, staticRenderFns } from "./HeaderAcompanhamento.vue?vue&type=template&id=204c629a"
import script from "./HeaderAcompanhamento.vue?vue&type=script&lang=js"
export * from "./HeaderAcompanhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports